import { useRouter } from "next/router";
import Link from "next/link";

export default function PreviewBanner() {
  const {
    query: { slug },
  } = useRouter();
  return (
    <section>
      <span>
        {slug ? (
          <>
            You’re previewing an <strong>unpublished draft</strong>
          </>
        ) : (
          "You’re in preview mode, seeing unpublished posts"
        )}
      </span>
      <Link href="/api/exit-preview">
        <a className="button">Exit preview</a>
      </Link>
      <style jsx>{`
        section {
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 16px;
          justify-content: center;
          text-align: center;
          background-color: #fff8c4;
          color: #927344;
          padding: 16px;
          font-size: 16px;
          margin-bottom: 24px;
        }
        .button {
          background-color: #ff6633;
          color: #fff !important;
          line-height: 1.25;
        }
        @media (max-width: 520px) {
          span {
            margin: 8px 0;
          }
        }
      `}</style>
    </section>
  );
}
